import { type IRemoveMembershipsHandler, RemoveMemberships } from '@telespot/authentication/use-cases';
import { MemberTopology } from '../../repositories';
import { ParseBaseRepository } from '../../parse-base.repository';

/**
 * Parse implementation of the {@link IRemoveMembershipsHandler} interface.
 *
 * @group Workspaces
 * @category Handlers
 */
export class RemoveMembershipsHandler extends ParseBaseRepository implements IRemoveMembershipsHandler {
  public async execute(command: RemoveMemberships): Promise<void> {
    const { membershipIds, batchSize } = command.details;
    try {
      const ParseMembership: typeof this.parse.Object = this.parse.Object.extend(MemberTopology.TABLE);
      const membershipsToDelete = membershipIds.map((id) => ParseMembership.createWithoutData(id));
      await this.parse.Object.destroyAll(membershipsToDelete, { batchSize: batchSize });
    } catch (error) {
      throw { type: 'UNKNOWN', message: error.message };
    }
  }
}
